import { FluxErrors } from './errors.js';
import { extractCode } from './utils/extract-codes.js';

export type FluxErrorCode = NonNullable<(typeof FluxErrorCodes)[keyof typeof FluxErrorCodes]>;
/**
 * Objeto com todos os códigos de erro disponíveis no Flux. Esse objeto é derivado
 * do objeto `FluxErrors`, ele é considerado uma enumeração dos códigos de erro.
 */
export const FluxErrorCodes = extractCode(FluxErrors);
